<div class="vw-toasts">
  <div class="vw-toast" [class]="t.type" *ngFor="let t of toastService.toasts">
    <span class="color-white">{{ t.text }}</span>
    <i class="fal fa-times pointer" (click)="deleteToast(t.toastId)"></i>
  </div>
</div>
